import { Flex, Typography } from "antd"

import InputNumberComponent from "../../../../../../Components/Input/InputNumber"

import styles from "../../../styles.module.less"

const { Text } = Typography

const PriceLevels = ({ label, levels, freeCount }) => (
  <Flex vertical={true} gap={8}>
    <Text>{label}</Text>

    {levels.map((level, index) => (
      <Flex gap={8} key={level.id}>
        <InputNumberComponent
          size="small"
          placeholder={"Range from"}
          disabled={true}
          value={index ? levels[index - 1]?.range_to + 1 : (freeCount || 0) + 1}
          className={styles.rangeValue}
        />

        <InputNumberComponent
          size="small"
          placeholder={"Range to"}
          disabled={true}
          value={level?.range_to}
          className={styles.rangeValue}
        />

        <InputNumberComponent
          size="small"
          prefix="$"
          precision={2}
          disabled={true}
          value={level?.price}
          className={styles.levelPrice}
        />
      </Flex>
    ))}
  </Flex>
)

export default PriceLevels
